<ng-container *ngIf="config">
  <div class="ribbon-container">
    <div class="ribbon" [style.background-color]="config.bgColor">
      {{ config.label }}
    </div>
  </div>

  <button
    class="click-target"
    type="button"
    (click)="toggleDetail()"
    [attr.aria-label]="'Environment: ' + config.label">
  </button>

  <div *ngIf="showDetail" class="detail-panel" [style.background-color]="config.detailBg">
    <div class="detail-title">{{ config.label }} Environment</div>
    <div *ngFor="let item of detailItems" class="detail-row">
      <span class="detail-label">{{ item.label }}</span>
      <span class="detail-value">{{ item.value }}</span>
    </div>
  </div>
</ng-container>
